/**
 * AWS Amplify Configuration for Face Liveness Detection
 * Amplify v6 için
 */

export const amplifyConfig = {
  Auth: {
    Cognito: {
      // Cognito Identity Pool for Liveness (unauthenticated access)
      identityPoolId: 'eu-west-1:5974a815-f841-4954-b665-ab5748705f2b',
      region: 'eu-west-1',
      allowGuestAccess: true,
    }
  },
  API: {
    REST: {
      'kres-api': {
        endpoint: 'https://r1zql1dill.execute-api.eu-central-1.amazonaws.com/prod',
        region: 'eu-central-1'
      }
    }
  }
};

// Liveness için EU-West-1 (Face Liveness sadece burada mevcut)
export const AWS_REGION = 'eu-west-1';
